/**
 * English site (algomoriEN): canonical / Organization URLs use www.algomori.com.
 * Preview hosts and localhost use the current origin.
 */
export function getPreferredSiteOrigin() {
  if (typeof window === 'undefined' || !window.location) return 'https://www.algomori.com'
  const { hostname, origin } = window.location
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local')) {
    return origin
  }
  if (hostname === 'algomori.com' || hostname === 'www.algomori.com') {
    return 'https://www.algomori.com'
  }
  return origin
}

function buildOrganizationJsonLd(siteOrigin) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AlgoMori Inc.',
    url: siteOrigin,
    logo: `${siteOrigin}/logo.png`,
    description:
      'Bioinformatics & AI for Life Sciences. Rigor, precision, and actionable insights.',
    foundingDate: '2025-11-18',
    knowsAbout: ['Biotechnology', 'Life sciences', 'Bioinformatics', 'Artificial intelligence'],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '12-12, Osaka Ekimae No. 2 Building, 1-2-2 Umeda, Kita-ku',
      addressLocality: 'Osaka',
      postalCode: '530-0001',
      addressCountry: 'JP',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'info@algomori.co.jp',
    },
  }
}

/**
 * Sets canonical URL, og:url, twitter:url, and Organization JSON-LD (no non-Schema fields such as `industry`).
 */
export function syncSiteSeoHead() {
  if (typeof document === 'undefined') return

  const siteOrigin = getPreferredSiteOrigin()
  const path = window.location.pathname + window.location.search
  const absoluteUrl = `${siteOrigin}${path}`

  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', absoluteUrl)

  const setOg = (property, content) => {
    const el = document.querySelector(`meta[property="${property}"]`)
    if (el) el.setAttribute('content', content)
  }
  setOg('og:url', absoluteUrl)
  setOg('twitter:url', absoluteUrl)

  const ldId = 'algomori-org-jsonld'
  let ld = document.getElementById(ldId)
  if (!ld) {
    ld = document.createElement('script')
    ld.type = 'application/ld+json'
    ld.id = ldId
    document.head.appendChild(ld)
  }
  ld.textContent = JSON.stringify(buildOrganizationJsonLd(siteOrigin))
}
